import { set } from '@/plugins/vuex'

export default {
  loginStatus: set('isLoggedIn'),
  userData: set('user'),
  dialogOpen: set('dialogOpen'),

  setRoomDialogOpen (state, payload) {
    localStorage.setItem('rooms_dialog', JSON.stringify(payload));
    state.roomDialogOpen = payload
  },
}
